import { Component, Input } from '@angular/core';
import { trigger, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-ai-alert',
  templateUrl: './ai-alert.component.html',
  styleUrls: ['./ai-alert.component.css'],
   animations: [
    trigger('fadeSlide', [
      transition(':enter', [ 
        style({ opacity: 0, transform: 'translate(-50%, -1rem)' }),
        animate('600ms ease-out', style({ opacity: 1, transform: 'translate(-50%, 0)' }))
      ]),
      transition(':leave', [ 
        animate('600ms ease-in', style({ opacity: 0, transform: 'translate(-50%, -1rem)' }))
      ])
    ])
  ]
})
export class AiAlertComponent {
  @Input() showAlert = false;
  @Input() message: string = 'AI-generated insights are directional and should be interpreted using business judgment.';
  @Input() showIcon: boolean = true;
  
  closeAlert(){
      this.showAlert = false; 
  }
  // closeAlert() {
  //   this.state = 'hide';
  //   setTimeout(() => {
  //     this.showAlert = false; 
  //   }, 600); 
  // }
}
